import React, { useEffect, useState, useRef } from "react";
import Aos from "aos";
import { fetchUserData, S3CDNURL, UpdateUserProfile, uploadFileAPI } from "../../../functionsMaster";
import { Link } from "react-router-dom";

const UserSettings = () => {
  const fileInputRef = useRef(null);
  const [imageSrc, setImageSrc] = useState(null);
  const [previewImage, setPreviewImage] = useState('');

  async function uploadFile(e, file, index = 'image') {
      e.preventDefault();
      const filePreview = e.target.files[0];
        if (filePreview && index === 'image') {
          setImageSrc(URL.createObjectURL(filePreview));
        }
      setUserData({ ...userData, apiCall: true });
      try {
          const data = await uploadFileAPI(file, index);
          if (data && data.file && data.file !== 0) {
              setUserData({ ...userData, apiCall: false, [index]: data.file});
          } else {
              alert(data.message);
              setUserData({ ...userData, apiCall: false});
          }
      } catch (e) {
          alert(e.message);
          setUserData({ ...userData, apiCall: false});
      }
  }

  const [userData, setUserData] = useState({
      address: '',
      licenseProofFront: '',
      idProofBack: '',
      idProofFront: '',
      apiCall: false,
      dob: '',
      image: '',
      email: '',
      mobile: '',
      emailAlt: '',
      mobileAlt: '',
      name: '',
    });

  useEffect(() => {
    Aos.init({ duration: 1200, once: true });
  }, []);

useEffect(() => {
    const fetchData = async () => {
      try {
        const userTemp = await fetchUserData();
        if (userTemp.status === 1) {
          setUserData(userTemp.data);
        } else {
          setUserData({});
        }
      } catch (error) {
        alert(error.message);
        console.log(error);
        //  window.location.href = "/";
      }
    };
    fetchData();
  }, []);

  const [message, setMessage] = useState({ status: 0, message: "" });

  return (
    <form
      onSubmit={ async(e) => {
        e.preventDefault();
        const data =  await UpdateUserProfile(userData);
        setMessage(data);
      }}
    >
      {/* Page Content */}
      <div className="content">
        <div className="container">
          <div className="row">
            {/* Settings Details */}
            <div className="col-md-12">
              <div className="settings-info">
                <div className="row">
                  {/* Basic Info */}
                  <div className="col-md-6">
                    <div className="profile-info-grid">
                      <div className="profile-info-header">
                        <h5>Basic Information</h5>
                        {/* <p>Information about user</p> */}
                      </div>
                      <div className="profile-inner">
                        <div className="profile-info-pic">
                          <div
                            className="profile-info-img"
                            onClick={() => {
                              if (fileInputRef && fileInputRef.current) {
                                fileInputRef.current.click();
                              }
                            }}
                          >
                            <img
                              src={imageSrc ? imageSrc : `${S3CDNURL}${userData.image}`}
                              alt={userData.name}
                            />
                          </div>
                          <div className="profile-info-content">
                            <h6>Profile picture</h6>
                            <p>PNG, JPEG under 15 MB</p>
                          </div>
                        </div>
                        <input
                          type="file"
                          ref={fileInputRef}
                          accept="image/*"
                          className="d-none"
                          onChange={(e) => {
                              if (e.target.files) {
                                uploadFile(e, e.target.files[0]);
                              }
                          }}
                        />
                        <div className="row">
                          <div className="col-md-12">
                            <div className="profile-form-group">
                              <label>
                                Full Name <span className="text-danger">*</span>
                              </label>
                              <input
                                type="text"
                                value={userData.name}
                                onChange={(e) => {
                                  setUserData({ ...userData, name: e.target.value });
                                }}
                                className="form-control"
                                placeholder="Enter First Name"
                              />
                            </div>
                          </div>

                          <div className="col-md-6">
                            <div className="profile-form-group">
                              <label>
                                Mobile{" "}
                                <span className="text-danger">*</span>
                              </label>
                              <input
                                type="text"
                                value={userData.mobile}
                                className="form-control"
                                placeholder="Enter Mobile Number"
                              />
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="profile-form-group">
                              <label>
                                Email <span className="text-danger">*</span>
                              </label>
                              <input
                                type="email"
                                value={userData.email}
                                className="form-control"
                                placeholder="Enter Email"
                              />
                            </div>
                          </div>

                          <div className="col-md-6">
                            <div className="profile-form-group">
                              <label>
                                Alternative Mobile{" "}
                                <span className="text-danger">*</span>
                              </label>
                              <input
                                type="text"
                                value={userData.mobileAlt}
                                onChange={(e) => {
                                  setUserData({ ...userData, mobileAlt: e.target.value });
                                }}
                                className="form-control"
                                placeholder="Enter Mobile Number"
                              />
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="profile-form-group">
                              <label>
                                Alternative Email <span className="text-danger">*</span>
                              </label>
                              <input
                                type="email"
                                value={userData.emailAlt}
                                onChange={(e) => {
                                  setUserData({ ...userData, emailAlt: e.target.value });
                                }}
                                className="form-control"
                                placeholder="Enter Email"
                              />
                            </div>
                          </div>

                        </div>
                      </div>
                    </div>
                  </div>
                  {/* /Basic Info */}
                  {/* Address Info */}
                  <div className="col-md-6">
                    <div className="profile-info-grid">
                      <div className="profile-info-header">
                        <h5>Address Information</h5>
                        {/* <p>Information about address of user</p> */}
                      </div>
                      <div className="profile-inner">
                        <div className="row">
                          <div className="col-md-12">
                            <div className="profile-form-group">
                              <label>
                                Address <span className="text-danger">*</span>
                              </label>
                              <input
                                type="text"
                                className="form-control"
                                placeholder="Enter Address"
                                defaultValue={""}
                                value={userData.address}
                                onChange={(e) => {
                                  setUserData({ ...userData, address: e.target.value });
                                }}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    
                    <div className="profile-info-grid">
                      <div className="profile-info-header">
                        <h5>Documents</h5>
                        {/* <p>Information about address of user</p> */}
                      </div>
                      <div className="profile-inner">
                        <div className="row">
                          <div className="col-md-12">
                            <div className="profile-form-group">
                              <label>
                                ID Proof Front
                                &nbsp;
                                <Link
                                  to="#"
                                  onClick={() => {
                                    setPreviewImage(userData.idProofFront);
                                  }}
                                  className={`btn btn-sm btn-primary ${userData.idProofFront ? '' : 'd-none'}`}
                                  data-bs-toggle="modal"
                                  data-bs-target="#bookingDetails"
                                >
                                  <i className="feather icon-eye" /> View
                                </Link>
                              </label>
                              <input
                                type="file"
                                accept="image/*"
                                className="form-control"
                                onChange={(e) => {
                                    if (e.target.files) {
                                      uploadFile(e, e.target.files[0], 'idProofFront');
                                    }
                                }}
                              />
                            </div>
                            <div className="profile-form-group">
                              <label>
                                ID Proof Back
                                &nbsp;
                                <Link
                                  to="#"
                                  onClick={() => {
                                    setPreviewImage(userData.idProofBack);
                                  }}
                                  className={`btn btn-sm btn-primary ${userData.idProofBack ? '' : 'd-none'}`}
                                  data-bs-toggle="modal"
                                  data-bs-target="#bookingDetails"
                                >
                                  <i className="feather icon-eye" /> View
                                </Link>
                              </label>
                              <input
                                type="file"
                                accept="image/*"
                                className="form-control"
                                onChange={(e) => {
                                    if (e.target.files) {
                                      uploadFile(e, e.target.files[0], 'idProofBack');
                                    }
                                }}
                              />
                            </div>

                            <div className="profile-form-group">
                              <label>
                                License Proof
                                &nbsp;
                                <Link
                                  to="#"
                                  onClick={() => {
                                    setPreviewImage(userData.licenseProofFront);
                                  }}
                                  className={`btn btn-sm btn-primary ${userData.licenseProofFront ? '' : 'd-none'}`}
                                  data-bs-toggle="modal"
                                  data-bs-target="#bookingDetails"
                                >
                                  <i className="feather icon-eye" /> View
                                </Link>
                              </label>
                              <input
                                type="file"
                                accept="image/*"
                                className="form-control"
                                onChange={(e) => {
                                    if (e.target.files) {
                                      uploadFile(e, e.target.files[0], 'licenseProofFront');
                                    }
                                }}
                              />
                            </div>

                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* /Address Info */}
                  {/* Profile Submit */}
                  {message.message !== "" && (
                    <div className={`alert alert-${message.status ? 'success' : 'danger'}`}>
                      {message.message}
                    </div>
                  )}
                  <div className="profile-submit-btn">
                    <button type="submit" className="btn btn-primary">
                      Save
                    </button>
                  </div>
                  {/* /Profile Submit */}
                </div>
              </div>
            </div>
            {/* /Settings Details */}
          </div>
        </div>
      </div>
      {/* /Page Content */}

<div
        className="modal new-modal multi-step fade"
        id="bookingDetails"
        data-keyboard="false"
        data-backdrop="static"
      >
        <div className="modal-dialog modal-dialog-centered modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <button
                type="button"
                className="close-btn"
                data-bs-dismiss="modal"
              >
                <span>×</span>
              </button>
            </div>
            <div className="modal-body">
              <img
                src={`${S3CDNURL}${previewImage}`}
                alt=""
                style={{ maxWidth: '100%' }}
              />
              <div className="modal-btn modal-btn-sm text-end"></div>
            </div>
          </div>
        </div>
      </div>

    </form>
  );
};

export default UserSettings;
